import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
  statelist: [],
  filterdetails: {},
  countrylist: [],
  code: '',
  oldRoute: "",
  email: {},
  mail_id: {},
  igst_tax: [],
  local_tax: [],
  total_tax: [],
  details: '',
  accounts: {},
  tax_main: [],
  sales_account: [],
  quot_status: [],
  order_status: [],
  customer_filter_list: [],
  vendor_filter_list: [],
  product_filter_list: [],
  admin: 0,
  org_details: {},
  user_name: '',
  app_urls: {},
  token: {},
  paymentmethod: {},
  retainermethod: {},
  customer_invoice_details: [],
  vendor_bill_details: [],
  fiscal_year: [],
  status: '',
  taglist: {},
  tds_acc_types: [],
  retainer_credit_invoice_details: '',
  retainer_credit_bill_details: '',
  print_option: 1,
  updated_id: "",
  network_error: "",
  message: "",
  reportsfilter: {},
  selectedfilter: {},
  message_type: '',
  primary_acc:{},
  module_path:'',
  allfilter_details:{
    customer:{
      details:'fetchCustomerFilterDetails',
      title:'Customer',
      path:'Customer',
      module:'customer'
      },
      products:{
        title: 'Product',
        path: 'Product',
        details: 'fetchProductFilterDetails',
        module:'products'
      },
      quotation:{
        title: 'Sales',
        path: 'Sales',
        details: 'fetchSalesDetails',
        type: 'quotation',
        module:'sales'
      },
      invoice:{
        title: 'Invoice',
        path: 'Invoice',
        details: 'fetchSalesDetails',
        type: 'invoice',
        module:'sales'
      },
      payment:{
        title: 'Payments Received',
        path: 'Payment',
        details: 'fetchPaymentmethod',
        type: 'payment_received',
        module:'payment'
      },
      customeradvance:{
        title: 'Customer Advance',
        path: 'CustomerAdvance',
        details: 'fetchPaymentmethod',
        type: 'customer_advance',
        module:'payment'
      },
      retainer:{
        title: 'Customer Deposit',
        path: 'RetainerInvoice',
        details: 'fetchRetainerInvoiceDetails',
        module:'retainer'
      },
      recurringinvoice:{
        title: 'Recurring Invoice',
        path: 'RecurringInvoice',
        details: 'fetchSalesDetails',
        type: 'recurring_invoice',
        module:'sales'
      },
      credit:{
        title: 'Credit Note',
        path: 'Credit',
        details: 'fetchCreditDetails',
        module:'credit'
      },
      amccontract:{
        title: 'AMC Contract',
        path: 'AMCContract',
        details: 'fetchamccontractdetails',
        module:'amccontract'
      },
      status_code: '',
      status_message: '',
      status_type: '',    
  }
}
const mutations = {
  SET_CODE(state, data) {
    state.status_code = data.code;
    state.status_message = data.status;
    state.status_type = data.type;
},
  LIST_DETAILS(state, data) {
    state.details = data
  },
  LIST_STATUS(state, data) {
    state.status = data
  },
  LIST_STATE(state, statelist) {
    state.statelist = statelist
  },
  LIST_COUNTRY(state, countrylist) {
    state.countrylist = countrylist
  },
  LIST_ID(state, updated_id) {
    state.updated_id = updated_id
  },

  LIST_IGST_TAX(state, igst_tax) {
    state.igst_tax = igst_tax
  },

  LIST_LOCAL_TAX(state, local_tax) {
    state.local_tax = local_tax
  },
  LIST_SALESACCOUNT(state, sales_account) {
    state.sales_account = sales_account
  },
  LIST_ORDER_STATUS(state, order_status) {
    state.order_status = order_status
  },
  LIST_QUOT_STATUS(state, quot_status) {
    state.quot_status = quot_status
  },
  LIST_CUSTOMER_DATA(state, customer_filter_list) {
    state.customer_filter_list = customer_filter_list
  },
  LIST_VENDOR_DATA(state, vendor_filter_list) {
    state.vendor_filter_list = vendor_filter_list
  },
  LIST_PRODUCT_DATA(state, product_filter_list) {
    state.product_filter_list = product_filter_list
  },
  LIST_PAYMENT_METHOD(state, data) {
    state.paymentmethod = data.data
    state.accounts = data.accounts
    state.total_tax = data.tax_list
    state.local_tax = data.local_tax
    state.igst_tax = data.igst_tax
    state.tax_main = data.tax_main
    state.tds_acc_types = data.tds_acc_types
    state.primary_acc = data.primary_acc
  },
  LIST_RETAINER_METHOD(state, data) {
    state.retainermethod = data
  },
  LIST_INVOICE_DETAILS(state, data) {
    state.customer_invoice_details = data
  },
  LIST_BILL_DETAILS(state, data) {
    state.vendor_bill_details = data
  },
  RETAINER_CREDIT_DETAILS(state, data) {
    state.retainer_credit_invoice_details = data
  },
  RETAINER_CREDIT_BILL_DETAILS(state, data) {
    state.retainer_credit_bill_details = data
  },
  TAG_LIST(state, data) {
    state.taglist = data
  },
  ERROR_STATUS(state, code) {
    state.network_error = code
  },
  DELETE_DROPDOWN(state, data) {
    state.code = data.status
    state.message = data.data.status
    state.message_type = data.data.type
  },
  MESSAGE_RESULT(state, message) {
    state.message = message
  },
  STATUS_CODE(state, code) {
    state.code = code
    state.error = ''
  },
  CUSTOM_FILTER_LIST(state, data) {
    state.reportsfilter = data.reportlist
    state.selectedfilter = data.defaultlist
  }
}
const actions = {
  // get price list details for particular product id
  pricelistrate({
    commit,
    rootState
  }, data) {
    return AppService.general.getpricelistrate(data, rootState.session.token)
      .then(response => {
        return response

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  getallcustomfilter({
    commit,
    rootState
  }, data) {
    return AppService.general.getallcustomfilter(data, rootState.session.token)
      .then(response => {
        commit('CUSTOM_FILTER_LIST', response.data) // getting all the list in the api call

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  deletecustomfilter({
    commit,
    rootState
  }, data) {
    return AppService.general.deletecustomfilter(data, rootState.session.token)
      .then((response) => {
        commit('CUSTOM_FILTER_LIST', response.data) // getting all the list in the api call
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  addsaveforfuturefilter({
    commit,
    rootState
  }, data) {
    return AppService.general.postcustomfilter(data, rootState.session.token)
      .then(response => {
        commit('CUSTOM_FILTER_LIST', response.data) // getting all the list in the api call
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchState({
    commit,
    rootState
  }) {
    return AppService.general.getState(rootState.session.token)
      .then(response => {
        commit('LIST_STATE', response.data.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchCountry({
    commit,
    rootState
  }) {
    return AppService.general.getCountry(rootState.session.token)
      .then(response => {

        commit('LIST_COUNTRY', response.data.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchtaglist({
    commit,
    rootState
  }) {
    return AppService.general.gettaglist(rootState.session.token)
      .then(response => {
        commit('TAG_LIST', response.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },

  fetchPaymentmethod({
    commit,
    rootState
  }) {
    return AppService.general.getPaymentmethod(rootState.session.token)
      .then(response => {

        commit('LIST_PAYMENT_METHOD', response.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  receipt({
    commit,
    rootState
  }, data) {

    return AppService.general.postReceipt(data, rootState.session.token)
      .then(response => {
        commit('SET_CODE', response.data)
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit('STATUS_CODE', response.status)
          rootState.general.email = response.data
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          rootState.general.network_error = 500 // getting all the list in the api call
        }
      })
  },
  fetchOrderStatus({
    commit,
    rootState
  }) {
    return AppService.general.getOrderStatus(rootState.session.token)
      .then(response => {
        commit('LIST_ORDER_STATUS', response.data.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchQuotStatus({
    commit,
    rootState
  }) {
    return AppService.general.getQuotStatus(rootState.session.token)
      .then(response => {
        commit('LIST_QUOT_STATUS', response.data.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchCustomerData({
    commit,
    rootState
  }, val) {

    return AppService.general.getCustomerData(val, rootState.session.token)
      .then(response => {
        commit('LIST_CUSTOMER_DATA', response.data.data.customer) // getting all the list in the api call
        return response.data.data.customer
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  exemptreasondelete({
    commit,
    rootState
  }, id) {
    return AppService.general.getexemptdelete(id, rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 201) {
          commit('DELETE_DROPDOWN', response)
        } else if (response.status == 200) {

          commit('DELETE_DROPDOWN', response)
          rootState.customer.exempt_detail = response.data.exempt_details
          // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },

  fetchCustomerAdvanceSearchData({
    commit,
    rootState
  }, val) {

    return AppService.general.postCustomerAdvanceSearchDatas(val, rootState.session.token)
      .then(response => {
        commit('LIST_CUSTOMER_DATA', response.data.data.customer) // getting all the list in the api call
      })
      .catch(error => {

        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchProductData({
    commit,
    rootState
  }, val) {
    return AppService.general.getProductData(val, rootState.session.token)
      .then(response => {
        commit('LIST_PRODUCT_DATA', response.data.data.product) // getting all the list in the api call
        return response.data.data.product
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchTax({
    commit,
    rootState
  }) {
    return AppService.general.getTax(rootState.session.token)
      .then(response => {
        commit('LIST_IGST_TAX', response.data.data.igst_tax)
        commit('LIST_LOCAL_TAX', response.data.data.local_tax)
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchSalesaccount({
    commit,
    rootState
  }) {
    return AppService.general.getSalesAccount(rootState.session.token)
      .then(response => {
        if (response.status == 200) {
          commit('LIST_SALESACCOUNT', response.data.data)
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  fetchCustomerInvoiceDetails({
    commit,
    rootState
  }, id) {
    return AppService.general.postCustomerInvoiceDetails(id, rootState.session.token)
      .then(response => {
        if (response.status == 200) {
          commit('LIST_INVOICE_DETAILS', response.data.data)
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },

  addTag({
    commit,
    rootState
  }, tag_name) {
    return AppService.general.postTag(tag_name, rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          rootState.amcservice.producttaglist = response.data.data
          commit('TAG_LIST', response.data.data) // getting all the list in the api call
          commit('STATUS_CODE', response.status) // getting all the list in the api call
          return response
        }

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  salesprojectdelete({
    commit,
    rootState
  }, id) {
    return AppService.general.SalProjectDelete(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 200) {

          rootState.sales.pjt_list = response.data.project_list

        }

        commit('DELETE_DROPDOWN', response) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  salespersondelete({
    commit,
    rootState
  }, id) {
    return AppService.general.SalPersonDelete(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 200) {
          rootState.sales.sales_person_list = response.data.salesperson_list
          rootState.amccontract.sales_person_list = response.data.salesperson_list
          rootState.credit.sales_person_list = response.data.salesperson_list
        }
        commit('DELETE_DROPDOWN', response) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  salestagdelete({
    commit,
    rootState
  }, id) {
    return AppService.general.SalTagDelete(id, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 200) {

          rootState.credit.tag_list = response.data.sales_tags
          rootState.sales.tag_list = response.data.sales_tags
          rootState.amccontract.tag_list = response.data.sales_tags
        }
        commit('DELETE_DROPDOWN', response) // getting all the list in the api call

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  producttagdelete({
    commit,
    rootState
  }, id) {
    return AppService.general.PdtTagDelete(id, rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 200) {
          rootState.products.producttaglist = response.data.pdt_tags
          rootState.amcservice.producttaglist = response.data.pdt_tags
        }

        commit('DELETE_DROPDOWN', response) // getting all the list in the api call

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  customertagdelete({
    commit,
    rootState
  }, id) {
    return AppService.general.CusTagDelete(id, rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 200) {
          rootState.customer.customertaglist = response.data.cus_tags
        }

        commit('DELETE_DROPDOWN', response) // getting all the list in the api call

      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },


  fetchStatus({
    commit,
    rootState
  }) {
    return AppService.general.getStatus(rootState.session.token)
      .then(response => {

        commit('LIST_STATUS', response.data) // getting all the list in the api call
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  availableretainerinvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postretainerinvoiceavailable(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data)
          commit('LIST_INVOICE_DETAILS', response.data.data) // getting all the list in the api call()
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })

  },

  availablepaymentinvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postpaymentinvoiceavailable(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('LIST_INVOICE_DETAILS', response.data.data) // getting all the list in the api call()
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })

  },

  availablecreditinvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postcreditinvoiceavailable(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('LIST_INVOICE_DETAILS', response.data.data) // getting all the list in the api call()
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })

  },

  updateRetainerInvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postUnusedRetainerUpdate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('RETAINER_CREDIT_DETAILS', response.data.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },


  updateCreditInvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postUnusedCreditUpdate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('RETAINER_CREDIT_DETAILS', response.data.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  updatemigrationdate({
    commit,
    rootState
  }, data) {
    return AppService.general.updatemigrationdate(data, rootState.session.token)
      .then(response => {
        commit('STATUS_CODE', response.status) // getting all the list in the api call
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  exemptdelete({
    commit,
    rootState
  }, id) {
    return AppService.general.exemptdelete(id, rootState.session.token)
      .then(response => {

        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else if (response.status == 201) {
          commit('DELETE_DROPDOWN', response)
        } else if (response.status == 200) {
          commit('DELETE_DROPDOWN', response)
          rootState.amcservice.exempt_reason_list = response.data.exempt_details
          rootState.products.exempt_reason_list = response.data.exempt_details
          rootState.productgroup.details.exempt_reason_list = response.data.exempt_details
          // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },

  availablecustomeradvanceinvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postcustomeradvanceinvoiceavailable(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('LIST_INVOICE_DETAILS', response.data.data) // getting all the list in the api call()
        }
        return response
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })

  },
  updateCustomerAdvanceInvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postUnusedCustomerAdvanceUpdate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('RETAINER_CREDIT_DETAILS', response.data.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },
  updatePaymentInvoiceInvoice({
    commit,
    rootState
  }, data) {
    return AppService.general.postUnusedPaymentInvoiceUpdate(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          commit("SET_CODE", response.data);
          commit('RETAINER_CREDIT_DETAILS', response.data.data) // getting all the list in the api call
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })
  },



  //  to create automatic code generate
  addautocode({
    commit,
    rootState
  }, data) {
    return AppService.general.postautogeneratecode(data, rootState.session.token)
      .then(response => {
        if (response.status == 203) {
          window.location.href = process.env.VUE_APP_LOGOUT_URL;
        } else {
          rootState.sales.auto_generate_code = response.data.auto_generate_code
          commit('DELETE_DROPDOWN', response)
          commit('LIST_ID', response.data.code_id) // getting all the list in the api call()
        }
      })
      .catch(error => {
        if (!error.response) {
          commit('ERROR_STATUS', 500) // getting all the list in the api call
        }
      })

  },

}
export default {
  namespaced,
  state,
  mutations,
  actions
}